export default __webpack_public_path__ + "static/media/plus.467483e4.webp";